import { Component, Inject } from '@angular/core';
import { ManagerService } from 'src/app/services/manager/manager.service';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { GlobalService } from 'src/app/services/global/global.service';
import { PaginationInstance } from 'ngx-pagination';
import { AppService } from 'src/app/services/app/app.service';
import { MatTableDataSource } from '@angular/material/table';
import { CommonService } from 'src/app/services/common/common.service';



@Component({
  selector: 'app-assigned-employee-list',
  templateUrl: './assigned-employee-list.component.html',
  styleUrls: ['./assigned-employee-list.component.scss']
})
export class AssignedEmployeeListComponent {

  //this variables are for pagination
  public maxPaginationSize = GlobalService.maxPaginationSize;
  public pageSizeOptions = GlobalService.pageSizeOptions;
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 1,
  };
  public count = 1

  //this variable is for search input
  public searchInput: string = '';
  private previousInputValue: string = '';


  public isSpinnerLoading = false
  public dataSourceEmp = new MatTableDataSource();
  public displayedColumnsEmp: string[] = ['name'];

  constructor(
    private managerService: ManagerService,
    public dialogRef: MatDialogRef<AssignedEmployeeListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private appService: AppService,
    private commonService: CommonService
  ) { }

  ngOnInit(): void {
    this.callAPI() //when component load we will call empoyee list api
  }


  //in this function we call api for empoyee list
  callAPI() {
    let data = {
      sh: this.searchInput.trim(),
      ma_i: this.data.ma_i,
      st: this.appService.startPageLogic(this.config.currentPage, this.config.itemsPerPage),
      r_p: this.config.itemsPerPage,
      f_a: [],
    }
    this.isSpinnerLoading = true

    this.managerService.assignedEmployeelist(data).subscribe({
      next: (success: any) => {
        if (success.status == 200) {
          this.isSpinnerLoading = false
          this.count = success.count
          this.previousInputValue = this.searchInput //here we set previous search input value
          this.dataSourceEmp = new MatTableDataSource(success.data)
          
        }
      },
      error: (error: any) => {
        // this.isSpinnerLoading=false
        this.isSpinnerLoading = false
        this.commonService.handleError(error);
      },
    });
  }


  //this functions is for search
  onSearch(event: any) {
    const inputValue = (event.target as HTMLInputElement).value;
    if (inputValue == '' && this.previousInputValue !== '') {
      this.callAPI()
    }
  }
  onGo() {
    if (this.searchInput.trim() != '') {
      this.callAPI()
    }
  }


  //this function is for pagination
  onPageSizeChange(event: Event) {
    const tar = event.target as HTMLInputElement
    this.config.itemsPerPage = Number(tar.value)
    this.config.currentPage = 1

    this.callAPI()
  }
  onPageChange(number: number) {
    this.config.currentPage = number;
    this.callAPI()
    // this.callAPI()
  }
}
